import * as React from 'react';
import { IRestCardCreateActivity } from '../../../../../../../types/rest/activity/IRestCardCreateActivity';
import { IActivityProps } from '../../../../boardDetails/activity/TabActivity/types';
import { TActivity } from '../../../../../../../store/activities/types';
import {
    ActivityItemBody
} from '../../../../boardDetails/activity/TabActivity/components/ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../../../../boardDetails/activity/TabActivity/components/ActivityHeader/ActivityHeader';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardActivityDelete`) : null;

export function CardActivityDelete ({
    activity
}: IActivityProps<IRestCardCreateActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { label } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} />}
            activity={activity}
        />
    );
}
